import "./revealInlineElement.css";

export function revealInlineElement(elementId, { focus = false, pulse = false } = {}) {
  requestAnimationFrame(() => {
    const element = document.getElementById(elementId);
    element?.scrollIntoView?.({ block: "nearest" });
    if (focus) element?.querySelector("button, input, select")?.focus();
    if (pulse && element) {
      element.classList.remove("inline-reveal-pulse");
      requestAnimationFrame(() => element.classList.add("inline-reveal-pulse"));
    }
  });
}
